import { BASE_PATH as l, BaseAPI as D, operationServerMap as p } from "../base.js";
import { DUMMY_BASE_URL as P, assertParamExists as C, createRequestFunction as S, serializeDataIfNeeded as h, setSearchParams as v, toPathString as y } from "../common.js";
import O from "axios";
var G = function(r) {
  return {
    productCommissionStatGetProductCommissionDetailPage: async (e, s = {}) => {
      C("productCommissionStatGetProductCommissionDetailPage", "productCommissionDetailQueryDTO", e);
      const i = new URL("/merchant/dc/product_commission/detail/page", P);
      let t;
      r && (t = r.baseOptions);
      const o = {
        method: "POST",
        ...t,
        ...s
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", v(i, m);
      let n = t && t.headers ? t.headers : {};
      return o.headers = {
        ...a,
        ...n,
        ...s.headers
      }, o.data = h(e, o, r), {
        url: y(i),
        options: o
      };
    },
    productCommissionStatGetProductCommissionSummary: async (e, s = {}) => {
      C("productCommissionStatGetProductCommissionSummary", "productCommissionDetailQueryDTO", e);
      const i = new URL("/merchant/dc/product_commission/summary", P);
      let t;
      r && (t = r.baseOptions);
      const o = {
        method: "POST",
        ...t,
        ...s
      }, a = {}, m = {};
      a["Content-Type"] = "application/json", v(i, m);
      let n = t && t.headers ? t.headers : {};
      return o.headers = {
        ...a,
        ...n,
        ...s.headers
      }, o.data = h(e, o, r), {
        url: y(i),
        options: o
      };
    }
  };
}, u = function(r) {
  const e = G(r);
  return {
    async productCommissionStatGetProductCommissionDetailPage(s, i) {
      var t, o;
      const a = await e.productCommissionStatGetProductCommissionDetailPage(s, i), m = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (o = p["ProductCommissionStatApi.productCommissionStatGetProductCommissionDetailPage"]) === null || o === void 0 || (o = o[m]) === null || o === void 0 ? void 0 : o.url;
      return (c, d) => S(a, O, l, r)(c, n || d);
    },
    async productCommissionStatGetProductCommissionSummary(s, i) {
      var t, o;
      const a = await e.productCommissionStatGetProductCommissionSummary(s, i), m = (t = r == null ? void 0 : r.serverIndex) !== null && t !== void 0 ? t : 0, n = (o = p["ProductCommissionStatApi.productCommissionStatGetProductCommissionSummary"]) === null || o === void 0 || (o = o[m]) === null || o === void 0 ? void 0 : o.url;
      return (c, d) => S(a, O, l, r)(c, n || d);
    }
  };
}, T = function(r, e, s) {
  const i = u(r);
  return {
    productCommissionStatGetProductCommissionDetailPage(t, o) {
      return i.productCommissionStatGetProductCommissionDetailPage(t.productCommissionDetailQueryDTO, o).then((a) => a(s, e));
    },
    productCommissionStatGetProductCommissionSummary(t, o) {
      return i.productCommissionStatGetProductCommissionSummary(t.productCommissionDetailQueryDTO, o).then((a) => a(s, e));
    }
  };
}, _ = class extends D {
  productCommissionStatGetProductCommissionDetailPage(r, e) {
    return u(this.configuration).productCommissionStatGetProductCommissionDetailPage(r.productCommissionDetailQueryDTO, e).then((s) => s(this.axios, this.basePath));
  }
  productCommissionStatGetProductCommissionSummary(r, e) {
    return u(this.configuration).productCommissionStatGetProductCommissionSummary(r.productCommissionDetailQueryDTO, e).then((s) => s(this.axios, this.basePath));
  }
};
export {
  _ as ProductCommissionStatApi,
  G as ProductCommissionStatApiAxiosParamCreator,
  T as ProductCommissionStatApiFactory,
  u as ProductCommissionStatApiFp
};

//# sourceMappingURL=product-commission-stat-api.js.map